import { enumify, Enumify } from '@mews/enumify';

function BaseHttpStatusCode() {}

const config = {
    BadRequest: 400,
    NotAuthorized: 401,
    Forbidden: 403,
    NotFound: 404,
    RequestEntityTooLarge: 413,
    Locked: 423,
    TooManyRequests: 429,
    InternalServerError: 500,
    BadGateway: 502,
    ServiceUnavailable: 503,
    Timeout: 504,
};
type Keys = keyof typeof config;
enumify<Keys, number>(BaseHttpStatusCode, 'HttpStatusCode', config);

export const HttpStatusCode = BaseHttpStatusCode as unknown as Enumify<Keys, number>;
